export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LkBurgerBtn.vue?vue&type=template&id=21e2389c&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkBurgerBtn.vue?vue&type=template&id=21e2389c&
// module id = 1594
// module chunks = 0